define('TescoMobile_DataLayer/js/view/upgrade-modal-options-mixin',['jquery'], function ($) {
  'use strict';

  var mixin = {
    triggerAddNewContract: function () {
      $('body').trigger('dl-add-new-contract');
      return this._super();
    },
    getSubscriptionsInfo: function (form) {
      this.subscriptionsInfo.subscribe(function (subscriptionsInfo) {
        $.data(document.body, 'subscriptions-count', subscriptionsInfo.length);
        $('body').trigger('customer-upgrade-subscriptions-loaded');
      });
      return this._super(form);
    }
  };
  return function (target) {
    return target.extend(mixin);
  };
});

